import React from 'react';
import Anime from 'react-anime';
import { isMobile } from 'react-device-detect';
import './RightPipe.scss';
export default ({ isActive }) => {
  const moveBall = {
    marginLeft: [
      { value: '-100%', duration: 0 },
      { value: (el, i) => isMobile ? '25%' : '30%', duration: 1000, easing: 'linear'}
    ],
    marginTop: [
      { value: 'auto', duration: 0 },
      { value: '120%', duration: 1000, delay: 1000, easing: 'linear'}
    ],
    direction: 'reverse'
  }
  return (
    <div className="right-elbow-pipe">
      {isActive && (
        <Anime {...moveBall} className="ball">
          <div></div>
        </Anime>
      )}
    </div>
  );
}